(function () {
  'use strict';

  var GRID_SELECTOR = '[data-collection-template-products]';
  var BLOCK_SELECTOR = '[data-content-block]';
  var PRODUCT_SELECTOR = '.c-collection__item:not([data-content-block])';
  var LOAD_MORE_SELECTOR = '[data-pagination-button]';
  var PADDED_ATTR = 'data-cb-padded';
  var MOBILE_BREAKPOINT = 1100;

  function getCols(grid) {
    var cs = getComputedStyle(grid);
    return cs.gridTemplateColumns.split(' ').filter(function (s) { return s.trim(); }).length || 1;
  }

  function isVisibleHere(block, isMobile) {
    var d = block.getAttribute('data-display-on') || 'Both';
    if (d === 'Both' || d === '') return true;
    if (d === 'Desktop only') return !isMobile;
    if (d === 'Mobile only') return isMobile;
    return true;
  }

  function computeSlot(block, cols, isMobile) {
    var rp = isMobile
      ? (block.getAttribute('data-row-position-mobile') || block.getAttribute('data-row-position'))
      : block.getAttribute('data-row-position');
    var rs = isMobile
      ? (block.getAttribute('data-row-side-mobile') || block.getAttribute('data-row-side'))
      : block.getAttribute('data-row-side');
    var bs = parseInt(block.getAttribute('data-block-size') || '1', 10) || 1;
    var rowPos = parseInt(rp, 10) || 1;
    var span = Math.min(bs, cols);
    var sideOffset = rs === 'Left Edge' ? 0 : (cols - span);
    return { slot: (rowPos - 1) * cols + sideOffset, span: span };
  }

  function init() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    var blocks = Array.prototype.slice.call(grid.querySelectorAll(BLOCK_SELECTOR));
    if (!blocks.length) return;

    var mo = null;
    var resizeTimer = null;
    var loadMoreClicked = false;

    function position() {
      if (mo) mo.disconnect();
      var cols = getCols(grid);
      var isMobile = window.innerWidth < MOBILE_BREAKPOINT;

      // Detach all tracked blocks first so accumulated-span math is clean
      blocks.forEach(function (b) {
        if (b.parentNode) b.parentNode.removeChild(b);
      });

      // Visible blocks: compute slot + span, sort by slot ascending
      var visible = blocks
        .filter(function (b) { return isVisibleHere(b, isMobile); })
        .map(function (b) {
          var c = computeSlot(b, cols, isMobile);
          return { el: b, slot: c.slot, span: c.span };
        })
        .sort(function (a, b) { return a.slot - b.slot; });

      var products = grid.querySelectorAll(PRODUCT_SELECTOR);
      var accumSpan = 0;
      visible.forEach(function (x) {
        var productIdx = x.slot - accumSpan;
        if (productIdx < 0) productIdx = 0;
        var target = products[productIdx];
        if (target && target.parentNode === grid) {
          grid.insertBefore(x.el, target);
        } else {
          grid.appendChild(x.el);
        }
        x.el.classList.add('is-cb-visible');
        accumSpan += x.span;
      });

      // Hidden-on-this-viewport blocks: append to end so they're in DOM (CSS hides via display:none)
      blocks.forEach(function (b) {
        if (!isVisibleHere(b, isMobile) && !b.parentNode) {
          grid.appendChild(b);
          b.classList.add('is-cb-visible');
        }
      });

      balanceGrid();

      if (mo) mo.observe(grid, { childList: true });
    }

    function unhidePadded() {
      Array.prototype.forEach.call(
        grid.querySelectorAll('[' + PADDED_ATTR + ']'),
        function (el) {
          el.style.display = '';
          el.removeAttribute(PADDED_ATTR);
        }
      );
    }

    function balanceGrid() {
      unhidePadded();
      if (loadMoreClicked) return;

      var cols = getCols(grid);
      var kids = grid.children;
      var totalSlots = 0;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (getComputedStyle(el).display === 'none') continue;
        totalSlots += el.classList.contains('two-column-grid') ? 2 : 1;
      }
      var remainder = totalSlots % cols;
      if (remainder === 0) return;

      var toHide = remainder;
      for (var j = kids.length - 1; j >= 0 && toHide > 0; j--) {
        var el2 = kids[j];
        if (el2.hasAttribute('data-content-block')) continue;
        if (getComputedStyle(el2).display === 'none') continue;
        el2.style.display = 'none';
        el2.setAttribute(PADDED_ATTR, '');
        toHide--;
      }
    }

    mo = new MutationObserver(function () {
      position();
    });

    var loadMoreBtn = document.querySelector(LOAD_MORE_SELECTOR);
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        loadMoreClicked = true;
        unhidePadded();
      }, true);
    }

    position();

    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(position, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
